import { AbstractControl } from '@angular/forms'

export function hasValidator(
  formControl: AbstractControl,
  validator: string,
): boolean {
  if (!formControl?.validator) return false
  const validatorFns = formControl.validator({} as AbstractControl)
  return validatorFns && validatorFns[validator]
}
